module.exports = __webpack_public_path__ + "GB.png?5a4fec29304269a1bdd7fe1a3c942a58";